<div style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Atendentes </span>
    <div class="flex justify-end">
      <div>
        <select class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
          aria-label=".form-select-lg" [formControl]="ordenarControl">
          <option selected>Ordenar</option>
          <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row gap-3 mt-4">
    <input
      type="text"
      class="form-control w-full sm:w-64"
      placeholder="Buscar por nome ou e-mail..."
      [formControl]="nameControl"
    />
    <select
      *ngIf="companies.length > 0"
      class="form-select w-full sm:w-64"
      [formControl]="companyControl"
    >
      <option value="">Todas as empresas</option>
      <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
    </select>
    <select class="form-select w-full sm:w-48" [formControl]="situacaoControl">
      <option *ngFor="let situacao of opcoesSituacao" [value]="situacao.value">{{ situacao.label }}</option>
    </select>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-atendentes [atendentes]="atendentes" [dadosPaginacao]="dadosPaginacao" (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
      (recarregarListagem)="carregarAtendentes()"></app-list-atendentes>

    <p *ngIf="listagemCarregada && atendentes.length === 0" class="py-10 text-center text-gray-500">
      Nenhum atendente encontrado com os filtros aplicados.
    </p>
  </div>

  <app-add-new-atendente (recarregarListagem)="carregarAtendentes()" [companyId]="companyId"
    [partnerId]="partnerId"></app-add-new-atendente>

  <hr class="my-10" />
</div>